import axios from "axios";
// 创建axios实例
const service = axios.create({
  baseURL: '', // api的base_url
  timeout: 100000, // 请求超时时间
  headers: { "Cache-Control": "no-cache", Pragma: "no-cache"}
});

// 添加请求拦截器
service.interceptors.request.use(
  request => {
    return request
  },
  error => {
    return Promise.reject(error);
  }
);

// 拦截返回的数据res,通过返回值直接获取到服务器的数据
service.interceptors.response.use(
  response => {
    
    const res = response.data;
    return res
  },
  error => {
    
    return Promise.reject(error);
  }
);

export default service;
